export enum AptVatCode {
    Iva22 = 1,
    Iva10 = 12,
}
